import { AddComment, Menu, MenuOpen } from "@mui/icons-material";
import { alpha, AppBar, Box, IconButton, Stack, Toolbar, Tooltip, Typography, useTheme } from "@mui/material";
import Logo from "components/Logo";
import { useTranslation } from "react-i18next";

const Topbar = ({ open, setOpen, title }) => {
	const theme = useTheme();
	const { t } = useTranslation(["common"]);
	return (
		<AppBar
			position={"fixed"}
			elevation={0}
			sx={{
				zIndex: (theme) => theme.zIndex.drawer,
				bgcolor: theme.palette.background.paper,
				color: "text.primary",
				borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
			}}>
			<Toolbar>
				<Stack
					width={1}
					direction="row"
					alignItems={"center"}
					justifyContent={"space-between"}>
					<Stack
						width={0}
						flex={1}
						direction="row"
						alignItems={"center"}
						gap={1}>
						<IconButton
							color="inherit"
							aria-label="open drawer"
							onClick={() => setOpen((prev) => !prev)}
							edge="start">
							{open ? <MenuOpen /> : <Menu />}
						</IconButton>
						<Box
							component="a"
							href="/app/"
							display={{ xs: "none", sm: "block" }}>
							<Logo />
						</Box>
						<Typography
							variant="h6"
							noWrap
							component="div">
							{title}
						</Typography>
					</Stack>
					<Stack
						flexBasis={1}
						direction="row"
						alignItems={"center"}>
						<Tooltip title={t("newChat")}>
							<IconButton
								href="/app/"
								edge="end">
								<AddComment />
							</IconButton>
						</Tooltip>
					</Stack>
				</Stack>
			</Toolbar>
		</AppBar>
	);
};

export default Topbar;
